import { render, staticRenderFns } from "./ReceiptList.vue?vue&type=template&id=989881c8&scoped=true&"
import script from "./ReceiptList.vue?vue&type=script&lang=ts&"
export * from "./ReceiptList.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptList.vue?vue&type=style&index=0&id=989881c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989881c8",
  null
  
)

export default component.exports